export * from './news-article.model';
export * from './news-article-popup.service';
export * from './news-article.service';
export * from './news-article-dialog.component';
export * from './news-article-delete-dialog.component';
export * from './news-article-detail.component';
export * from './news-article.component';
export * from './news-article.route';



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/news-article/index.ts